<template>
    <div class="page">
        <div class="page__inner">
            <div class="page-header">
                <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
                <el-button v-if="!isEdit" @click="saveHandler" type="primary" size="medium">保存</el-button>
                <el-button v-else @click="editHandler" type="primary" size="medium">保存</el-button>
            </div>
            <div class="page-main" :style="{height: `${containerHeight}px`}">
                <div class="container">
                    <div class="form-container">
                        <el-form ref="form" :model="queryForm" :rules="formRule" label-width="80px">
                            <el-form-item label="信息板块" prop="module">
                                <el-select @change="moduleChange" v-if="!isEdit" v-model="queryForm.module" placeholder="请选择信息板块">
                                    <el-option :label="moduleItem.value" :value="moduleItem.code" :key="index" v-for="(moduleItem, index) in moduleList"></el-option>
                                </el-select>
                                <span v-else>{{queryForm.moduleName}}</span>
                            </el-form-item>
                            <el-form-item label="别名" prop="aliasName">
                                <el-input :maxlength="20" v-model="queryForm.aliasName" placeholder="请输入信息板块别名" />
                            </el-form-item>
                            <el-form-item label="logo" prop="logoUrl">
                                <uploader
                                    prefixPath="heartsOfRiver"
                                    v-model="files"
                                    :multiple="false"
                                    :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                    showMode="image"
                                    showResult="image"
                                >
                                </uploader>
                            </el-form-item>
                            <el-form-item label="排序" prop="sortNumber">
                                <el-input :maxlength="20" :min="0" type="number" v-model="queryForm.sortNumber" placeholder="请输入排序号" />
                            </el-form-item>
                            <el-form-item label="负责人" prop="admin">
                                <address-book ref="addressStudent" v-model="queryForm.admin" :config="teacherAddressConfigData"></address-book>
                            </el-form-item>
                            <el-form-item label="描述" prop="desc">
                                <el-input type="textarea" :rows="5" v-model="queryForm.desc"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin.js';
    import Uploader from '@/components/Uploader/WebUploader';
    import {findDicsByCode} from '@/api/common/common';
    import AddressBook from '@/components/AddressBook/indexExpand';
    import {addTrainType, getTrainTypeById, updateTrainType} from '@/api/setting/setting';

    export default {
        name: "moduleAdd",
        data() {
            const adminValidator = (rule, value, callback) => {
                if(this.queryForm.admin.userJson.length === 0) {
                    callback(new Error('请选择负责人'));
                } else {
                    callback();
                }
            };

            return {
                isEdit: !!this.$route.query.id,
                id: this.$route.query.id,
                containerHeight: 0,
                teacherAddressConfigData: {
                    title: '请选择负责人',
                    depart: {target: 'user', departType: 't', userTypes: '1'},
                    group: false
                },
                files: [],
                queryForm: {
                    module: 0,
                    moduleName: '',
                    aliasName: '',
                    logoUrl: '',
                    sortNumber: 0,
                    admin: {
                        departJson: [],
                        groupJson: [],
                        userJson: []
                    },
                    desc: ''
                },
                formRule: {
                    module: [{
                        required: true
                    }],
                    aliasName: [{
                        required: true,
                        trigger: 'blur',
                        message: '请输入信息板块别名'
                    }],
                    logoUrl: [{
                        required: true,
                        message: '请上传logo图片'
                    }],
                    sortNumber:[{
                        required: true,
                        trigger: 'blur',
                        message: '请输入排序号'
                    }],
                    admin: [{
                        required: true,
                        trigger: 'blur',
                        validator: adminValidator
                    }],
                },
                moduleList: []
            }
        },
        components: {AddressBook, Uploader},
        mixins: [baseMixin],
        mounted() {
            this.containerHeight = window.innerHeight - 350;
        },
        created() {
            findDicsByCode({
                dicCode: 'throughtrain'
            })
                .then(res => res.data)
                .then(data => {
                    if(data.result) {
                        this.moduleList = data.data;
                        if(data.data.length !== 0) {
                            this.queryForm.module = data.data[0].code;
                            if(!this.isEdit) {
                                this.queryForm.aliasName = data.data[0].value;
                                this.queryForm.logoUrl = data.data[0].remark;
                            }
                        }
                    }
                });
            if(this.isEdit) {
                getTrainTypeById({
                    typeId: this.id
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            const pageData = data.data;
                            this.queryForm = {
                                module: 1,
                                moduleName: pageData.dictionaryName,
                                logoUrl: '',
                                admin: {
                                    departJson: [],
                                    groupJson: [],
                                    userJson: JSON.parse(pageData.manUserJson)
                                },
                                aliasName: pageData.name,
                                desc: pageData.remarkContent,
                                sortNumber: pageData.orderNo
                            };
                            const logoUrl = pageData.logoUrl.indexOf('?') !== -1 ? pageData.logoUrl.slice(0, pageData.logoUrl.indexOf('?')) : pageData.logoUrl;
                            const fileName = logoUrl.match(/^.+\/(.+?)$/)[1];
                            this.files = [{
                                fileUrl: logoUrl,
                                fileName
                            }];
                        }
                    })
            }

        },
        methods: {
            // 保存
            saveHandler() {
                if(this.files.length !== 0) {
                    this.queryForm.logoUrl = this.files[0].fileUrl;
                }
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        const args = {
                            dictionaryCode: this.queryForm.module,
                            dictionaryName: this.moduleList.find(({code}) => code === this.queryForm.module).value,
                            logoUrl: this.queryForm.logoUrl,
                            manUserJson: this.queryForm.admin.userJson,
                            name: this.queryForm.aliasName,
                            orderNo: this.queryForm.sortNumber,
                            remarkContent: this.queryForm.desc,
                        };
                        addTrainType(args)
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.$message({
                                        type: 'success',
                                        message: '新增成功'
                                    });
                                    setTimeout(() => {
                                        this.$router.back();
                                    }, 1000);
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    }
                })
            },
            // 编辑
            editHandler() {
                if(this.files.length !== 0) {
                    this.queryForm.logoUrl = this.files[0].fileUrl;
                }
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        const args = {
                            id: this.id,
                            logoUrl: this.queryForm.logoUrl,
                            manUserJson: this.queryForm.admin.userJson,
                            name: this.queryForm.aliasName,
                            orderNo: this.queryForm.sortNumber,
                            remarkContent: this.queryForm.desc,
                        };
                        updateTrainType(args)
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.$message({
                                        type: 'success',
                                        message: '编辑成功'
                                    });
                                    setTimeout(() => {
                                        this.$router.back();
                                    }, 500);
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    }
                })
            },
            // logo上传前
            beforeUploadHandler(file) {
                const ext = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
                const extList = ['jpg', 'png', 'bmp', 'jpeg'];
                if(extList.indexOf(ext) === -1) {
                    this.$message({
                        message: `logo后缀名必须是[${extList.join(', ')}]`,
                        type: 'error'
                    });
                    return false;
                }
            },
            // logo上传成功
            uploadSuccess(data) {
                this.queryForm.logoUrl = data.data.url;
            },
            // 删除logo
            deletePic() {
                this.queryForm.logoUrl = '';
            },
            moduleChange() {
                this.queryForm.aliasName = this.moduleList.find(({code}) => code === this.queryForm.module).value;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../../commonsPC/styles/mixins";

    @include reset-global;

    .page {
        background-color: #F1F1F1;
        box-sizing: border-box;
    }
    .page__inner {
        background-color: #fff;
        width: 1200px;
        margin: 0 auto;
        padding: 20px;
        box-sizing: border-box;
    }
    .page-main {
        padding: 20px 0 0 0;
    }
    .container {
        height: 100%;
        overflow-y: auto;
    }
    .form-container {
        margin: 0 auto;
        width: 70%;
    }
    .pic-item {
        @include cover-bg;
        @include wh(130px, 130px);
        border: 1px solid #ccc;
        float: left;
        margin: 0 10px 10px 0;
        position: relative;
        .delete-icon {
            cursor: pointer;
            background-image: url(../../../assets/images/wxcep_phone_close.png);
            z-index: 1000;
            position: absolute;
            right: 0;
            top: 0;
            @include wh(30px, 30px);
            background-size: cover;
        }
    }

    .upload-hint {
        width: 130px;
        height: 130px;
        float: left;
        border: 1px solid #ccc;
        margin-right: 10px;
        margin-bottom: 10px;
        background: url(../../../assets/images/picinput.png) no-repeat;
        background-position: center center;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/setting/moduleSetting/moduleAddEdit.vue